module.exports = __webpack_public_path__ + "assets/models/DefaultAvatar-b5992250e3ec585b050cf37e3b028e17.glb";